import { Suspense, lazy } from "react";
import { NavLink, Outlet } from "react-router-dom";

// const Navbar = lazy(() => import("./Navbar"));
// const Sidebar = lazy(() => import("../../../components/Sidebar"));
// const Footer = lazy(() => import("../../../components/Footer"));

export default function StudentQuizComponent2() {
  return (
    <Suspense fallback={<>Loading...</>}>
      <div className="main_container">
        {/* <Sidebar /> */}
        {/* <Navbar /> */}
        <div className="right_col" role="main">
          <ul className="nav nav-pills mb-3 right-col-tabs">
            <li className="nav-item me-2">
              <NavLink
                to="dashboard"
                className={({ isActive }) =>
                  `text-center nav-link ${isActive ? "active" : ""}`
                }
              >
                Dashboard
              </NavLink>
            </li>

            <li className="nav-item me-2">
              <NavLink
                to="registeredQuizzes"
                className={({ isActive }) =>
                  `text-center nav-link ${isActive ? "active" : ""}`
                }
              >
                Registered Quizzes
              </NavLink>
            </li>

            <li className="nav-item  me-2">
              <NavLink
                to="completeQuizzes"
                className={({ isActive }) =>
                  `text-center nav-link ${isActive ? "active" : ""}`
                }
              >
                Completed Quizzes
              </NavLink>
            </li>
            {/* <li className="nav-item ">
              <NavLink
                to="aboutQuiz"
                className={({ isActive }) =>
                  `text-center nav-link ${isActive ? "active" : ""}`
                }
              >
                About Quiz
              </NavLink>
            </li> */}
          </ul>
          <br />
          <div className="tab-content" id="pills-tabContent">
            {/* 🔑 The child route content renders here */}
            <Outlet />
          </div>

          {/* <Footer /> */}
        </div>
      </div>
    </Suspense>
  );
}
